import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface ResubscribeConfirmModalProps {
  show: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ResubscribeConfirmModal: React.FC<ResubscribeConfirmModalProps> = ({
  show,
  email,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Resubscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <strong>Important Legal Notice</strong>
        </Alert>
        <p>
          You are about to resubscribe <strong>{email}</strong> to marketing emails.
        </p>
        <p className="mb-1">
          <strong>Before proceeding, you must confirm:</strong>
        </p>
        <ul>
          <li>You have <strong>explicit written consent</strong> from this customer to send them marketing emails</li>
          <li>This action complies with CAN-SPAM Act, GDPR, and other applicable anti-spam regulations</li>
          <li>The customer has clearly opted-in to receive marketing communications</li>
        </ul>
        <Alert variant="danger" className="mb-0 mt-3">
          <small>
            <strong>Warning:</strong> Sending unsolicited marketing emails without consent may result in legal penalties
            and damage to our sender reputation.
          </small>
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          I Confirm - Resubscribe
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
